import { render, staticRenderFns } from "./DocutaxRequests.vue?vue&type=template&id=d99d7c4c&scoped=true&"
import script from "./DocutaxRequests.vue?vue&type=script&lang=js&"
export * from "./DocutaxRequests.vue?vue&type=script&lang=js&"
import style0 from "./DocutaxRequests.vue?vue&type=style&index=0&id=d99d7c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99d7c4c",
  null
  
)

export default component.exports